/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiCareersHero } from "@/types/strapi";
import { ColumnStandardCount } from "@/types/tokens/grid";

import { ButtonVariantKeys } from "@/tokens/configs/button_config";

import { Button } from "@/ui/atoms/button";
import { GridColumn } from "@/ui/atoms/grid_column";
import { GridContainer } from "@/ui/atoms/grid_container";
import { Media } from "@/ui/atoms/media";
import { Text } from "@/ui/atoms/text";

import { useTypedTheme } from "@/util/hooks/theme_hooks";

export const CareersHero: FunctionComponent<StrapiCareersHero> = (props) => {
    /**
     * Theme
     */
    const theme = useTypedTheme();

    /**
     * Rendering
     */
    const renderTeamMedia = () => {
        return props.Team_Media.map((_teamMedia, _index) => {
            return (
                <GridColumn
                    columnSpan={{
                        extraSmall: "full",
                        medium: 6,
                    }}
                    columnStart={{
                        extraSmall: 1,
                        medium: (6 * (_index % 2) + 1) as ColumnStandardCount,
                    }}
                    key={`careers-hero::team-media::${_teamMedia.id}`}
                    marginTop="CareersHeroTeam"
                    tag="figure"
                >
                    <Media {..._teamMedia} />

                    <figcaption>
                        <Text
                            color={theme.text.textSecondary}
                            fontSize="CareerCaptionText"
                            marginTop="CareersHeroTeamCaption"
                        >
                            {_teamMedia.Caption}
                        </Text>
                    </figcaption>
                </GridColumn>
            );
        });
    };

    return (
        <GridContainer marginTop="CareersHero">
            <Text
                columnSpan={{
                    extraSmall: "full",
                    medium: 7,
                }}
                columnStart={1}
                fontSize="CareerHeadline"
                tag="h1"
            >
                {props.Headline}
            </Text>

            <GridColumn
                className={css({
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                })}
                columnSpan={{
                    extraSmall: "full",
                    medium: 5,
                    large: 4,
                }}
                columnStart={{
                    extraSmall: 1,
                    medium: 8,
                    large: 9,
                }}
            >
                <Text
                    fontSize="CareerDefaultText"
                    marginTop="CareersHeroSubHeadline"
                    shouldBalanceWrap={false}
                    tag="h2"
                    themeKey="textPrimary"
                >
                    {props.Subheadline}
                </Text>

                <Button
                    className={css({ width: "fit-content" })}
                    href={props.CTA.URL}
                    marginTop="CareersHeroCTA"
                    variant={
                        props.CTA.Appearance.toLowerCase() as ButtonVariantKeys
                    }
                >
                    {props.CTA.Text}
                </Button>
            </GridColumn>

            {renderTeamMedia()}
        </GridContainer>
    );
};
